// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonScreen-module_container__zCWfx {
    bottom: 0;
    left: 0;
    min-width: 288px;
    overflow: auto;
    position: fixed;
    right: 0;
    top: 0;
}

.CommonScreen-module_inner__JIMYj {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    padding: 72px 24px 92px 24px;
}

.CommonScreen-module_content__Idupo {
    width: 100%;
    max-width: 504px;
}

.CommonScreen-module_mainText__cEAj9 {
    display: inline-block;
    font-size: 17px;
    line-height: 24px;
    margin-top: 24px;
}

@media screen and (min-width: 1920px) {
    .CommonScreen-module_mainText__cEAj9 {
        font-size: 20px;
        line-height: 32px;
    }
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/CommonScreen/CommonScreen.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,OAAO;IACP,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".container {\n    bottom: 0;\n    left: 0;\n    min-width: 288px;\n    overflow: auto;\n    position: fixed;\n    right: 0;\n    top: 0;\n}\n\n.inner {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    flex: 1;\n    padding: 72px 24px 92px 24px;\n}\n\n.content {\n    width: 100%;\n    max-width: 504px;\n}\n\n.mainText {\n    display: inline-block;\n    font-size: 17px;\n    line-height: 24px;\n    margin-top: 24px;\n}\n\n@media screen and (min-width: 1920px) {\n    .mainText {\n        font-size: 20px;\n        line-height: 32px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CommonScreen-module_container__zCWfx`,
	"inner": `CommonScreen-module_inner__JIMYj`,
	"content": `CommonScreen-module_content__Idupo`,
	"mainText": `CommonScreen-module_mainText__cEAj9`
};
export default ___CSS_LOADER_EXPORT___;
